export default {
    // TODO - ponechat zakomentované styly protože se to bude hodit jako styly do menu v budoucnu
    root: function (_a) {
        var state = _a.state;
        return ({
            class: [
                'tw-static tw-flex tw-gap-2',
                // 'tw-text-white hover:tw-bg-primary-800 tw-rounded',
                'tw-transition tw-duration-200',
                // '[&_[data-pc-section=root]_svg]:tw-transition',
                {
                // @ts-ignore
                // '[&_[data-pc-section=root]_svg]:tw-rotate-45 ': state.d_visible,
                // @ts-ignore
                // '[&_[[data-pc-section=root]_svg]:tw-rotate-0': !state.d_visible,
                },
            ],
        });
    },
    list: function (_a) {
        var state = _a.state;
        return ({
            class: [
                // Spacing
                'tw-m-0 tw-p-0 tw-absolute',
                // 'tw-top-10',
                // Layout & Flexbox
                'tw-list-none tw-flex tw-items-center tw-justify-center',
                // Transitions
                'tw-transition tw-delay-200',
                // Z-Index (Positioning)
                'tw-z-20',
                // State
                // @ts-ignore
                { 'tw-invisible': !state.d_visible },
            ],
        });
    },
    item: function (_a) {
        var props = _a.props, context = _a.context;
        return ({
            class: [
                'tw-transform tw-transition-all tw-duration-200 tw-ease-out',
                // Conditional Appearance
                context.hidden ? 'tw-opacity-0 tw-scale-0' : 'tw-opacity-100 tw-scale-100',
                // Conditional Spacing
                {
                    'tw-my-1 first:tw-mb-2': props.direction == 'up' && props.type == 'linear',
                    'tw-my-1 first:tw-mt-2': props.direction == 'down' && props.type == 'linear',
                    'tw-mx-1 first:tw-mr-2': props.direction == 'left' && props.type == 'linear',
                    'tw-mx-1 first:tw-ml-2': props.direction == 'right' && props.type == 'linear',
                },
                // Conditional Positioning
                { 'tw-absolute': props.type !== 'linear' },
            ],
        });
    },
    mask: function (_a) {
        var state = _a.state;
        return ({
            class: [
                // Base Styles
                'tw-fixed tw-left-0 tw-top-0 tw-w-full tw-h-full tw-transition-opacity tw-duration-250 tw-ease-in-out tw-bg-black/40 tw-z-10',
                // Conditional Appearance
                {
                    // @ts-ignore
                    'tw-opacity-0 tw-pointer-events-none': !state.d_visible,
                    // @ts-ignore
                    'tw-opacity-100 tw-transition-opacity tw-duration-400 tw-ease-in-out': state.d_visible,
                },
            ],
        });
    },
};
